/*
 *  GRAMAZON — self-hosted product reviews, reveal control.
 *  Every review is already in the DOM; this only flips a class. No fetching,
 *  no pagination, no app script.
 */
(function () {
  'use strict';

  function bind(root) {
    if (root.dataset.gzReviewsBound === '1') return;
    var button = root.querySelector('[data-gz-reviews-more]');
    if (!button) return;
    root.dataset.gzReviewsBound = '1';

    button.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (!expanded) {
        var top = root.getBoundingClientRect().top + window.pageYOffset;
        if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-gz-reviews]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', init);
})();
